<div class="register__kiwisaver-container">
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="errors message-box message--warning" *ngIf="registerFailText$ | async">
            <p [innerHTML]="registerFailText$ | async"></p>
        </div>
        <div class="title" style="position: relative;">
            <mat-select formControlName="userTitle" placeholder="Title" disableOptionCentering
                class="a-dropdown a-dropdown--medium">
                <mat-option *ngFor="let title of userTitles" [value]='title'>{{title}}</mat-option>
            </mat-select>
            <app-tooltip [tooltipText]="userTitleTooltipText" class="title__tooltip">
            </app-tooltip>
        </div>
        <div class="first-name">
            <mat-form-field appearance="outline">
                <input matInput placeholder="First name" formControlName="firstName">
            </mat-form-field>
        </div>
        <div class="last-name">
            <mat-form-field appearance="outline">
                <input matInput placeholder="Last name" formControlName="lastName">
            </mat-form-field>
        </div>
        <div class="email-address">
            <mat-form-field appearance="outline">
                <input matInput placeholder="Email address" formControlName="email">
            </mat-form-field>
        </div>
        <div class="date-of-birth">
            <mat-form-field appearance="outline" class="date-of-birth__form-field">
                <input matInput [matDatepicker]="dateofbirthpicker" placeholder="Date of birth"
                    formControlName="dateOfBirth">
                <mat-datepicker-toggle matSuffix [for]="dateofbirthpicker"></mat-datepicker-toggle>
                <mat-datepicker #dateofbirthpicker></mat-datepicker>
            </mat-form-field>
            <div *ngIf="dateOfBirth.touched && dateOfBirth.errors">
                <mat-error *ngIf="dateOfBirth.errors?.required">
                    Date of birth is required
                </mat-error>
                <mat-error *ngIf="dateOfBirth.errors?.datemin">
                    Are you sure that is your date of birth?
                </mat-error>               
            </div>
            <app-tooltip [tooltipText]="dobTooltipText" class="title__tooltip">
            </app-tooltip>
        </div>
        <div class="ird-number">
            <mat-form-field appearance="outline">
                <input matInput placeholder="IRD number" formControlName="irdNumber" (focusout)="formatIrd($event)">
            </mat-form-field>
            <div *ngIf="irdNumber.touched && irdNumber.errors">
                <mat-error *ngIf="irdNumber.errors?.required">
                    IRD number is required
                </mat-error>
                <mat-error *ngIf="irdNumber.errors?.pattern">
                    IRD number must have the format 123-123-123 or 12-123-123
                </mat-error>
            </div>
        </div>
        <div class="pir-tax-rate">
            <mat-select formControlName="pirTaxRate" placeholder="Tax rate (PIR)" disableOptionCentering
                class="a-dropdown a-dropdown--medium" style="flex: 1;">
                <mat-option *ngFor="let rate of (PIRTaxRates$ | async)" [value]='rate.value'>{{rate.key}}</mat-option>
            </mat-select>
            <i [popper]="pirHelp" [popperTrigger]="'click'" [popperHideOnClickOutside]="true"
                [popperHideOnScroll]="true" [popperApplyClass]="'popper_content'" [popperApplyArrowClass]="'popper_arrow'" 
                class="information-icon pir-rate-tooltip">i</i>
            <popper-content #pirHelp>
                <p class="popper-text">A prescribed investor rate (PIR) is your tax rate used to calculate how much tax you’ll pay on income that you
                    have earned on your investment in a portfolio investment entity (PIE). </p>
                <p class="popper-text">For further info visit the <a class="popper-text popper-link" href="https://www.ird.govt.nz/roles/portfolio-investment-entities/find-my-prescribed-investor-rate" target="_blank">Inland Revenue</a> website.</p>
            </popper-content>
        </div>
        <button class="a-rounded-button--primary a-rounded-button" type="submit"
            [disabled]="registerForm?.invalid || isDisabled">Register</button>
    </form>
</div>